import { buildAstState } from '..';

/**
 * 获取一组图片的压缩格式；每个图片压缩格式均相等时，整体为该值
 * @param basenames
 * @returns
 */
export const getAutoImageFormat = (basenames: string[]) => {
  const formats = buildAstState.data.autoImageFormats ?? {};

  const _formats: string[] = [];
  basenames.forEach((basename) => {
    // 这里很重要，formats很有可能不存在basename的format，这里就需要使用默认值
    _formats.push(formats[basename] ?? buildAstState.data.imageFormatDefault);
  });

  const _format = _formats[0];
  const isSame = _formats.every((item) => item == _format);
  return isSame ? _format : buildAstState.data.imagesFormatDefault;
};
